var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVocalSynthesis = function SvgVocalSynthesis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.499 18.407a6.14 6.14 0 0 0 5.506-6.105v-.108a.631.631 0 0 0-1.263 0v.108a4.874 4.874 0 0 1-9.749 0v-.108a.631.631 0 1 0-1.263 0v.108a6.14 6.14 0 0 0 5.506 6.105v2.855H11.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.867 15.416a3.22 3.22 0 0 1-3.222-3.222V4.42a3.222 3.222 0 1 1 6.445 0v7.773a3.22 3.22 0 0 1-3.223 3.222m-1.96-3.222a1.96 1.96 0 0 0 3.92 0V4.42a1.96 1.96 0 0 0-3.92 0z",
    clipRule: "evenodd"
  })));
};
export default SvgVocalSynthesis;